import Breadcrumb from '@/components/common/Breadcrumb';

const MBSConversionMain = () => {
  return (
    <div>
      <Breadcrumb />
      <div className="card">
        <h1 className="text-2xl font-bold text-admin-text mb-4">MBS変換</h1>
        <p className="text-admin-textLight mb-6">
          MBS形式への変換処理を実行します。
        </p>
        <div className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded">
          <p className="text-sm">
            この機能は今後のPBIで実装予定です。
          </p>
        </div>
      </div>
    </div>
  );
};

export default MBSConversionMain;
